export const SET_MAP_LOADED = 'SET_MAP_LOADED'
export const SET_VIDEO_LOADED = 'SET_VIDEO_LOADED'
export const SET_HERO_ANIMATION = 'SET_HERO_ANIMATION'
export const SET_PLACE_PICKER_LOADED = 'SET_PLACE_PICKER_LOADED'

export const SET_AGE_VALIDITY = 'SET_AGE_VALIDITY'

export const SET_PLACES_LIST = 'SET_PLACES_LIST'
export const SET_PLACE_DETAILS = 'SET_PLACE_DETAILS'
export const SET_ACTIVE_PLACE = 'SET_ACTIVE_PLACE'
export const TOGGLE_MODE = 'TOGGLE_MODE'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'

export const SET_FILTERS = 'SET_FILTERS'
export const SET_AVAILABLE_FILTERS = 'SET_AVAILABLE_FILTERS'

export const ACTIVATE_PLACE_PICKER = 'ACTIVATE_PLACE_PICKER'
export const DEACTIVATE_PLACE_PICKER = 'DEACTIVATE_PLACE_PICKER'
export const SET_PLACE_PICKER_POSITION = 'SET_PLACE_PICKER_POSITION'
export const SHOW_PLACE_PICKER = 'SHOW_PLACE_PICKER'
export const HIDE_PLACE_PICKER = 'HIDE_PLACE_PICKER'
export const SET_PLACE_ID = 'SET_PLACE_ID'
export const SET_PLACE_TITLE = 'SET_PLACE_TITLE'

export const SET_CONTEST_DESCRIPTION = 'SET_CONTEST_DESCRIPTION'
export const SET_CONTEST_SUCCESS = 'SET_CONTEST_SUCCESS'
export const UNSET_CONTEST_SUCCESS = 'UNSET_CONTEST_SUCCESS'
export const SET_CONTEST_PLACE = 'SET_CONTEST_PLACE'

export const SET_ADD_PLACE_DESCRIPTION = 'SET_ADD_PLACE_DESCRIPTION'
export const SET_ADD_PLACE_SUCCESS = 'SET_ADD_PLACE_SUCCESS'
export const UNSET_ADD_PLACE_SUCCESS = 'UNSET_ADD_PLACE_SUCCESS'
export const SET_ADD_PLACE_PLACE = 'SET_ADD_PLACE_PLACE'

export const SET_NEW_PLACE = 'SET_NEW_PLACE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js